// HEADER
// ===================================================

var header = {

    settings: {
        call_menu: $('header .call-menu'),
        call_menu_trigger: $('header .js-call-menu-trigger'),
    },

    init: function() {
        // Mobile Call Menu
        this.settings.call_menu_trigger.on('click', header.callMenu);
    },

    // Call Menu
    callMenu: function() {
        if (!header.settings.call_menu.hasClass('open')) {
            header.settings.call_menu.addClass('open');
            header.settings.call_menu.slideDown();
        } else {
            header.settings.call_menu.removeClass('open');
            header.settings.call_menu.slideUp();
        }
    },

};
header.init();